"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUuid = void 0;
const jsbi_1 = __importDefault(require("jsbi"));
const uuid_1 = require("uuid");
function generateUuid() {
    let str = (0, uuid_1.v4)();
    str = str.replace(/-/g, '');
    str = jsbi_1.default.BigInt('0x' + str).toString(36);
    return str;
}
exports.generateUuid = generateUuid;
//# sourceMappingURL=index.js.map